import { __require as requireAsync } from "./async.js";
import { __require as requireObjectifier } from "./objectifier.js";
import { __require as requireParser } from "./parser.js";
import { __require as requireSync } from "./sync.js";
var postcssJs;
var hasRequiredPostcssJs;
function requirePostcssJs() {
  if (hasRequiredPostcssJs) return postcssJs;
  hasRequiredPostcssJs = 1;
  let async = requireAsync();
  let objectify = requireObjectifier();
  let parse = requireParser();
  let sync = requireSync();
  postcssJs = {
    objectify,
    parse,
    async,
    sync
  };
  return postcssJs;
}
export {
  requirePostcssJs as __require
};
//# sourceMappingURL=index2.js.map
